// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.A4Vrs1JmvS5P8D {
  position: relative;
  min-width: 750px;
  max-width: 880px;
  margin: auto;
  border-radius: 12px;
  background-color: var(--ds-surface, #ffffff);
}
.eCq90MNbzT_95E {
  display: block;
  width: 100%;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.gw3Ha5Doo4H_Io {
  padding: 32px 140px 40px 140px;
  text-align: center;
}
.TkaUsorrI66Sxo {
  display: flex;
  justify-content: center;
  margin-top: 40px;
  column-gap: 8px;
}
.UnmbEeaCBvcbHa {
  position: absolute;
  top: 8px;
  right: 16px;
  color: #ffffff;
}
.UnmbEeaCBvcbHa:hover,
.UnmbEeaCBvcbHa:active {
  color: #ffffff;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gaAnnouncementModal": `A4Vrs1JmvS5P8D`,
	"headingImage": `eCq90MNbzT_95E`,
	"contentContainer": `gw3Ha5Doo4H_Io`,
	"ctasContainer": `TkaUsorrI66Sxo`,
	"closeButton": `UnmbEeaCBvcbHa`
};
export default ___CSS_LOADER_EXPORT___;
